
export const SEARCH_CUSTOMERS_BY_CODE_REQUEST_SUCCESS = 'SEARCH_CUSTOMERS_BY_CODE_REQUEST_SUCCESS';
export const SEARCH_CUSTOMERS_BY_CODE_REQUEST_FAILED = 'SEARCH_CUSTOMERS_BY_CODE_REQUEST_FAILED';

export const SEARCH_CUSTOMERS_BY_NAME_REQUEST_SUCCESS = 'SEARCH_CUSTOMERS_BY_NAME_REQUEST_SUCCESS';
export const SEARCH_CUSTOMERS_BY_NAME_REQUEST_FAILED = 'SEARCH_CUSTOMERS_BY_NAME_REQUEST_FAILED';
